export function locate(el, attr = "data-id") {
    let node = el;
    if (el?.changedTouches) {
        const { clientX, clientY } = el.changedTouches[0];
        node = document.elementFromPoint(clientX, clientY);
    }
    else if (!el.tagName && el.target) {
        node = el.target;
    }
    while (node) {
        if (node.getAttribute) {
            const id = node.getAttribute(attr);
            if (id)
                return node;
        }
        node = node.parentNode;
    }
    return null;
}
export function locateID(el, attr = "data-id") {
    const node = locate(el, attr);
    if (node) {
        return getID(node, attr);
    }
    return null;
}
export function getID(node, attr = "data-id") {
    const id = node.getAttribute(attr);
    const numId = parseInt(id);
    return isNaN(numId) || numId.toString() != id ? id : numId;
}
//# sourceMappingURL=locate.js.map